import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { EmailReferenceParameterDto } from '../../_models/email-reference-parameter-dto';
import { AccProjectRawDto } from '../../shared-acc-board-approval-module/_models/acc-project-raw-dto';
const ɵ0 = () => AccProjectRawDto, ɵ1 = () => EmailReferenceParameterDto;
export class AccAddParameterDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", AccProjectRawDto)
], AccAddParameterDto.prototype, "projectData", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", EmailReferenceParameterDto)
], AccAddParameterDto.prototype, "emailReference", void 0);
export { ɵ0, ɵ1 };
